import { render, staticRenderFns } from "./changshaOrder.vue?vue&type=template&id=0500cd8d&scoped=true&"
import script from "./changshaOrder.vue?vue&type=script&lang=ts&"
export * from "./changshaOrder.vue?vue&type=script&lang=ts&"
import style0 from "./changshaOrder.vue?vue&type=style&index=0&id=0500cd8d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0500cd8d",
  null
  
)

export default component.exports